import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, FormGroup, FormArray, FormControl } from '@angular/forms';
import * as ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import { ModelList } from 'projects/core/src/include/modellist';
import { Condition, Filter, FilterMode, Notification, NotificationMessages } from 'projects/core/src/include/structures';
import { NotificationService } from 'projects/core/src/lib/notification.service';
import { SettingNotificationDetailComponent } from '../detail/detail.component';


@Component({
  selector: 'app-notification',
  templateUrl: './notification.component.html',
  styleUrls: ['./notification.component.sass']
})
export class SettingNotificationComponent extends ModelList<Notification> implements OnInit {

  public Editor = ClassicEditor;
  editorOn=true;


  filter_type:Filter=new Filter();
  /*
  selectedNotify:Notification={} as Notification;

  gateway_email:NotificationMessages;
  gateway_sms:NotificationMessages;
  gateway_whatsapp:NotificationMessages;
  gateway_app:NotificationMessages;
  */
  constructor(
    private notificationService: NotificationService,
    
    
    private fb1: UntypedFormBuilder,
  ) { 
    super(notificationService,fb1);
    this.detailViewModal=SettingNotificationDetailComponent
  }

  ngOnInit(): void {
    this.title='Notifiche';

    super.ngOnInit.apply(this, arguments); 

   


    this.filter_type.mode=FilterMode.normal;
    this.filter_type.fields=[];
    this.filter_type.fields.push("n.table");
    this.filter_type.value="";
    this.filter.push(this.filter_type);

    this.ordering.field="n.id";
    this.paging_count=999999;
    this.getItems();

  }
    /*
  addNotification(){
    let r:Notification={} as Notification;
    r.status=1;
    
   
    this.selectedNotify=r;
  }

  setNotify(record:Notification){
    
    this.selectedNotify=Object.assign({}, record);

    this.selectedNotify.conditionsArray=[];
    if(this.selectedNotify.conditions!="")
      this.selectedNotify.conditionsArray=JSON.parse(this.selectedNotify.conditions);


    if(this.selectedNotify.gateways==undefined)
      this.selectedNotify.gateways=[];
    

    if(this.selectedNotify.gateways.length>0){
      for(let i=0;i<this.selectedNotify.gateways.length;i++)
        switch(this.selectedNotify.gateways[i].gateway){
          case "email":
            this.gateway_email=this.selectedNotify.gateways[i];
            break;
          case "sms":
            this.gateway_sms=this.selectedNotify.gateways[i];
            break;
          case "whatsapp":
            this.gateway_whatsapp=this.selectedNotify.gateways[i];
            break;
          case "app":
            this.gateway_app=this.selectedNotify.gateways[i];
            break;
          
          }
      
    }else{
      this.gateway_email={} as NotificationMessages;
      this.gateway_email.gateway="email";
      this.selectedNotify.gateways.push(this.gateway_email);

      this.gateway_sms={} as NotificationMessages;
      this.gateway_sms.gateway="sms";
      this.selectedNotify.gateways.push(this.gateway_sms);

      this.gateway_whatsapp={} as NotificationMessages;
      this.gateway_whatsapp.gateway="whatsapp";
      this.selectedNotify.gateways.push(this.gateway_whatsapp);

      this.gateway_app={} as NotificationMessages;
      this.gateway_app.gateway="app";
      this.selectedNotify.gateways.push(this.gateway_app);


    }
      
      
   

  }

  confirmNotify(){
    this.selectedNotify.conditions=JSON.stringify(this.selectedNotify.conditionsArray);
    this.notificationService.save(this.selectedNotify,(id)=>{
      this.getItems();
    });
  }
*/
    
  confirm_delete(id){
    confirm("Eliminare l'elemento?")?this.delete(id):false;
  }



}
